import BaseProxy from './BaseProxy';

class Ad extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/posts', parameters);
    }

    async getAll(params = {}) {
        return this.submit('get', '/all', params);
    }

    async addUserAd(id = null) {
        return this.submit('post', `/user/post/${id}`);
    }
}

export default Ad;



// WEBPACK FOOTER //
// ./src/api/Ad.js